export default "__VITE_ASSET__9FtbYeKc__"